import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classes from "./DoubleCalander.module.css";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { StaticDateRangePicker } from "@mui/x-date-pickers-pro/StaticDateRangePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import enLocale from "date-fns/locale/en-US";
// import { LocalizationProvider, LocalizationProviderProps } from '@mui/x-date-pickers'

export const DoubleCalander = ({ value, setValue }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={enLocale}>
      <style jsx>{`
        .PrivatePickersSlideTransition-root {
          min-height: 256px !important;
          // min-height: 220px !important;
        }
        .MuiDateRangePickerDay-rangeIntervalDayHighlight {
          background-color: #edf0f7;
        }
        .Mui-selected {
          background-color: #4d55e5 !important;
        }
        .MuiTypography-subtitle1 {
          font-style: normal;
          font-family: "inter-600";
          font-size: 16px;
          line-height: 24px;
          color: #222222;
        }
        .MuiDateRangePickerDay-day {
          font-style: normal;
          font-family: "inter-600";
          font-size: 14px;
          line-height: 16px;
          color: #222222;
        }
        .Mui-disabled {
          color: #b5b5b5;
        }
       
        .mehru span.MuiTypography-caption {
          position: relative;
          font-size: 0;
        }
        .mehru span.MuiTypography-caption:before {
          font-family: "inter-500";
          font-size: 14px;
          line-height: 20px;
          color: #717171;
          position: absolute;
          left: 15px;
        }
        .mehru span.MuiTypography-caption:nth-child(1):before {
          content: "Sun";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;
        }
        .mehru span.MuiTypography-caption:nth-child(2):before {
          content: "Mon";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;

        }
        .mehru span.MuiTypography-caption:nth-child(3):before {
          content: "Tue";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;

        }
        .mehru span.MuiTypography-caption:nth-child(4):before {
          content: "Wed";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;

        }
        .mehru span.MuiTypography-caption:nth-child(5):before {
          content: "Thu";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;

        }
        .mehru span.MuiTypography-caption:nth-child(6):before {
          content: "Fri";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;

        }
        .mehru span.MuiTypography-caption:nth-child(7):before {
          content: "Sat";
          transform: translateX(-50%);
          position: absolute;
          left: 50%;

        }
      `}</style>
      <StaticDateRangePicker
        displayStaticWrapperAs="desktop"
        className={`mehru ${[classes.DoubleCalander].join(" ")}`}
        value={value}
        minDate={Date.now()}
        onChange={(newValue) => {
          setValue(newValue);
        }}
        renderInput={(startProps, endProps) => (
          <React.Fragment>
            <TextField {...startProps} className="doubleDatePickerInner1" />
            <Box sx={{ mx: 2 }}> to </Box>
            <TextField {...endProps} className="doubleDatePickerInner1" />
          </React.Fragment>
        )}
      />
    </LocalizationProvider>
  );
};

DoubleCalander.propTypes = {
  value: PropTypes.array,
  setValue: PropTypes.func,
};

DoubleCalander.defaultProps = {
  value: [null, null],
};
